<template>
  <v-container>
    <v-row>
      <div class="d-flex align-center flex-column"  v-for="(post, index) in posts" :key="index">
        <BlogPost :post="post" ></BlogPost>
        <v-spacer></v-spacer>
      </div>
    </v-row>
  </v-container>
</template>

<script>
  import BlogPost from "./BlogPost.vue";
  import JSON_DATA from "../assets/blogPosts.json"
  export default {
    name: 'BlogMain',
    components: { BlogPost },
    data() {
        return {
            posts: JSON_DATA.posts
        };
    }
}
</script>
